var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18V10.0588H1.58824V15.3061L15.3061 1.58824H10.0588V0H18V7.94118H16.4118V2.69391L2.69391 16.4118H7.94118V18H0Z",
    fill: "url(#paint0_linear_1588_2256)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1588_2256",
    x1: 0,
    y1: 9,
    x2: 18,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52AE32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006535"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorExpand);
export default __webpack_public_path__ + "static/media/vector-expand.4ffeaa66ef07e05f700f5239dcffebe6.svg";
export { ForwardRef as ReactComponent };